import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {
    download: 1,
    as: 'link',
  },
  progress: 0,
  result: undefined,
  error: undefined,
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.converter.data = {
      ...state.modulo.autofacturacion.converter.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.autofacturacion.converter.progress = progress;
  });
};

const converter = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.autofacturacion.converter.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
      onUploadProgress,
    };

    const { data } = store.state.modulo.autofacturacion.converter;

    let formData = new FormData();

    formData.append('file', data.file);
    formData.append('download', data.download);
    formData.append('as', data.as);

    const response = await Http.post(`${window.BONJOUR_URL}/api/cedirama/converter`, formData, options);

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.autofacturacion.converter.busy = false;
      state.modulo.autofacturacion.converter.progress = 100;
      state.modulo.autofacturacion.converter.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.autofacturacion.converter.busy = false;
      state.modulo.autofacturacion.converter.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.modulo.autofacturacion.converter.busy = false;
    });
  }
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.converter = { ...initialState };
  });
};

const AutofacturacionUploadStoreConverter = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    converter,
  },
};

export default AutofacturacionUploadStoreConverter;
